import React from 'react';
import { useInView } from 'react-intersection-observer';
import './Media.css';

const Media = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const mediaCategories = [
    {
      id: 'newsletter',
      icon: 'fas fa-newspaper',
      title: 'Newsletter',
      description: 'Stay informed with insights, analysis, and thought leadership on business assurance, governance, and strategic execution.',
      color: '#D6AD60'
    },
    {
      id: 'clips',
      icon: 'fas fa-video',
      title: 'Short Clip Media',
      description: 'Quick, impactful videos covering key concepts in GARC, business excellence, and polymathic thinking.',
      color: '#B68D40'
    },
    {
      id: 'podcasts',
      icon: 'fas fa-podcast',
      title: 'Podcasts',
      description: 'Deep-dive conversations exploring complex business challenges, leadership strategies, and interdisciplinary expertise.',
      color: '#D6AD60'
    },
    {
      id: 'events',
      icon: 'fas fa-calendar-alt',
      title: 'Events',
      description: 'Join us for webinars, workshops, and conferences featuring expert insights on governance, risk, compliance, and business excellence.',
      color: '#B68D40'
    },
    {
      id: 'books',
      icon: 'fas fa-book',
      title: 'Books and Publications',
      description: 'Comprehensive resources on governance, risk management, compliance, audit, and integrated business functions.',
      color: '#D6AD60'
    },
    {
      id: 'tools',
      icon: 'fas fa-tools',
      title: 'Software and Tools',
      description: 'Practical frameworks, templates, and digital solutions to enhance your GRC and business excellence capabilities.',
      color: '#B68D40'
    }
  ];

  return (
    <section id="media" className="media-section" ref={ref}>
      <div className="container">
        {/* Banner Message */}
        <div className={`core-relationship ${inView ? 'fade-in' : ''}`}>
          <div className="relationship-card">
            <p className="relationship-text">
              Transform fragmented business functions into unified strategic ecosystems—led by a globally certified executive advisor's 20+ years of cross-border strategic expertise.
            </p>
          </div>
        </div>

        <div className={`video-wrapper ${inView ? 'fade-in' : ''}`}>
          <div className="video-container">
            <video 
              controls
              poster="/The Polymath IQ.png"
              className="promo-video"
            >
              <source src="/Video/Polymath IQ_ Homepage_Final.mp4" type="video/mp4" />
              Your browser does not support video playback.
            </video>
          </div>
        </div>

        <div className={`media-header ${inView ? 'fade-in' : ''}`}>
          <h2 className="section-title center">INSIGHTS & RESOURCES</h2>
          <div className="title-underline center"></div>
          <p className="media-intro">
            Explore a comprehensive collection of resources designed to expand your understanding of 
            integrated business assurance and polymathic leadership.
          </p>
        </div>

        <div className="media-grid">
          {mediaCategories.map((category, index) => (
            <div 
              key={category.id}
              className={`media-card ${inView ? 'fade-in' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="media-icon-wrapper">
                <div className="media-icon" style={{ borderColor: category.color }}>
                  <i className={category.icon}></i>
                </div>
              </div>
              <div className="media-content">
                <h3 className="media-title">{category.title}</h3>
                <div className="coming-soon-label">
                  <i className="fas fa-clock"></i>
                  <span>Coming Soon</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={`media-cta ${inView ? 'fade-in' : ''}`}>
          <div className="cta-content">
            <i className="fas fa-bell"></i>
            <h3>Get Notified</h3>
            <p>
              Be the first to know when new resources become available. Follow us on social media or 
              reach out via email to stay connected.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Media;

